import handleMediaQueryChange from "../helpers/_media_query";

let mobileStnLastScrollTop = 0;
let hasInjectedFloatPlayerStyles = false;

const FLOAT_PLAYER_DEFAULT_STYLES = `
.voltax-mp-container-sticky.floatContainer {
    position: relative !important;
}
`;

const injectFloatPlayerDefaultStyles = (shadowRoot) => {
    if (!shadowRoot || hasInjectedFloatPlayerStyles) return;

    const style = document.createElement("style");
    style.setAttribute("data-tsn-stn-float", "");
    style.textContent = FLOAT_PLAYER_DEFAULT_STYLES;
    shadowRoot.appendChild(style);
    hasInjectedFloatPlayerStyles = true;
};

const setFloatPlayerVisibility = (player, floatPlayer, currentScrollTop) => {
    if (currentScrollTop < player.offsetTop) {
        floatPlayer.style.setProperty("display", "none", "important");
        floatPlayer.style.removeProperty("position");
    } else {
        floatPlayer.style.setProperty("display", "flex", "important");
    }
};

const setFloatPlayerTransition = (floatPlayer) => {
    floatPlayer.style.transition = "top 0.2s cubic-bezier(0.4, 0, 0.2, 1)";
};

const updateFloatPlayerStyle = (floatPlayer, topValue) => {
    floatPlayer.style.setProperty("position", "fixed", "important");
    floatPlayer.style.setProperty("top", topValue, "important");
};

const getStickyNavOffset = (mainMenu, secondaryMenu) => {
    const navigationv3 = Boolean(
        document.querySelector("[data-navigation-version='v3']"),
    );
    const secondaryHeight = secondaryMenu?.offsetHeight || 0;

    if (navigationv3) return secondaryHeight;

    return mainMenu.offsetHeight + secondaryHeight;
};

const setMobileStnFloat = () => {
    const mainMenu = document.querySelector("#mainNavigation");
    const secondaryMenu = document.querySelector("#secondaryMenu");
    const tickerMenu = document.querySelector(
        "nav#tickerNavigation:not(.hidden):not(.md\\:block)",
    );
    const stnPlayer = document.querySelector("[data-stn-player]");
    const stnRenderedPlayer = document.querySelector("#voltax-mp-video");
    const stnFloatPlayer = stnRenderedPlayer?.shadowRoot.querySelector(
        ".voltax-mp-container-sticky.floatContainer",
    );
    const hasDefaultSkin =
        Boolean(document.querySelector("[data-skin='']")) ||
        Boolean(document.querySelector("[data-skin='skin-140th.css']"));

    if (!stnFloatPlayer || !mainMenu) return;

    injectFloatPlayerDefaultStyles(stnRenderedPlayer.shadowRoot);
    setFloatPlayerTransition(stnFloatPlayer);

    const { scrollY: currentScrollTop } = window;
    const navigationHeight =
        mainMenu.offsetHeight + (secondaryMenu?.offsetHeight || 0);
    const stickyNavOffset = getStickyNavOffset(mainMenu, secondaryMenu);
    const tickerHeight = tickerMenu?.offsetHeight || 0;

    if (currentScrollTop > mobileStnLastScrollTop) {
        if (hasDefaultSkin) {
            updateFloatPlayerStyle(stnFloatPlayer, `${stickyNavOffset}px`);
        } else {
            updateFloatPlayerStyle(stnFloatPlayer, "0");
        }

        if (currentScrollTop <= navigationHeight) {
            const adjustedTop =
                navigationHeight - currentScrollTop + tickerHeight;
            updateFloatPlayerStyle(stnFloatPlayer, `${adjustedTop}px`);
        }
    } else {
        updateFloatPlayerStyle(stnFloatPlayer, `${stickyNavOffset}px`);

        if (tickerMenu && currentScrollTop <= tickerHeight) {
            const adjustedTop =
                navigationHeight + (tickerHeight - currentScrollTop);
            updateFloatPlayerStyle(stnFloatPlayer, `${adjustedTop}px`);
        }
    }

    setFloatPlayerVisibility(stnPlayer, stnFloatPlayer, currentScrollTop);

    mobileStnLastScrollTop = currentScrollTop;
};

const stnScrollHandler = () => {
    window.addEventListener("scroll", setMobileStnFloat);
};

export const mobileStnFloatBehavour = () => {
    handleMediaQueryChange(stnScrollHandler, null);
};
